import { OTPDataItemTableType, OTPFormType } from 'entities/sendOTP/types';

export const useUpdateDefaultValues = (data: OTPDataItemTableType | null): OTPFormType => ({
  displayed_name: data?.displayed_name || '',
  country_id: data?.country_id || null,
  priority: data?.priority !== undefined ? data.priority : 0,
  limit_per_day: data?.limit_per_day || null,
  limit_per_month: data?.limit_per_month || null,
  retry_time: data?.retry_time || null,
  is_enabled: data?.is_enabled || undefined,
});
